import type { Theme } from '@mui/material';

const menu = (): Theme['components'] => ({
  MuiMenu: {
    styleOverrides: {
      paper: ({ theme }) => ({
        marginBlockStart: theme.spacing(0.5),
        boxShadow: 'var(--mui-customShadows-lg)',
      }),
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 0,
        paddingBlock: theme.spacing(2),
        color: 'var(--mui-palette-text-primary)',
        '&:hover': {
          backgroundColor: 'var(--mui-palette-primary-dark)',
        },
        '&.Mui-selected:not(:has(input))': {
          color: 'var(--mui-palette-primary-dark) !important',
          backgroundColor: 'var(--mui-palette-primary-main) !important',
          '& .MuiListItemIcon-root': {
            color: 'var(--mui-palette-primary-dark)',
          },
          '&& *': {
            color: 'var(--mui-palette-primary-dark)',
          },
          '&:hover': {
            backgroundColor: 'var(--mui-palette-primary-main)',
          },
        },
        '&.Mui-selected': {
          background: 'transparent',
        },
        '&.Mui-selected:hover': {
          backgroundColor: 'var(--mui-palette-primary-dark)',
        },
        '&.Mui-disabled': {
          color: 'var(--mui-palette-text-disabled)',
          opacity: 1,
        },
      }),
    },
  },
});

export { menu };
